<aside class="container-fluid">
    <header class="row header">
        <section class="row ">
            <div class="col">
                <figure class="figure logo-brand m-top1">
                    <img src="./assets/images/live-red.png" class="figure-img img-fluid rounded" alt="...">
                  </figure>
            </div>
            <div class="col">
                <div class="flt-r">
                    <button *ngIf="auth.userAutenticado()" (click)="salir()" class="button btn-first">Salir</button>
                    <figure class="figure flt-r logo-brand">
                        <img src="./assets/images/red-fams.png" class="figure-img img-fluid rounded" alt="...">
                    </figure>
                </div>
            </div>
        </section>
    </header>

    <article class="row">
        <router-outlet></router-outlet>
    </article>

    <footer class="row header">
        <div class="col">
            <ul class="list-link">
            <li><a href="https://red-larousse.com.mx/" class="simple-link" target="_blank">
                <img src="./assets/images/logo-red-h.png" alt="">
            </a></li>
            </ul>
        </div>
    </footer>
</aside>